module.exports = __webpack_public_path__ + "static/colors-Optimized.1feae651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client-screens/colors-Optimized.png
// module id = 604
// module chunks = 213720915766396